import { useTargetingContext } from '@openx/components-targeting/utils/context/TargetingContext.tsx';
import { PackageFields, type PackageFormState } from '@openx/types/package.ts';
import { TargetingFields } from '@openx/types/targeting/targeting.ts';
import { useTargeting } from './useTargeting.tsx';

export const useFilteredTargetingItems = (packageState: PackageFormState) => {
  const targeting = useTargeting();
  const { isOa } = useTargetingContext();

  const hasContextualSegmentsCard = targeting.some(({ field }) => field === TargetingFields.CONTEXTUAL_SEGMENTS);
  const hasContextualSegments = Boolean(
    packageState[PackageFields.TARGETING]?.[TargetingFields.CONTEXTUAL_SEGMENTS]?.length
  );

  return targeting.filter(({ field }) => {
    if (field === TargetingFields.METACATEGORY) {
      return (
        packageState[PackageFields.TARGETING]?.[field]?.excludes?.length ||
        packageState[PackageFields.TARGETING]?.[field]?.includes?.val?.length ||
        packageState[PackageFields.TARGETING]?.[field]?.keywords?.includes?.length ||
        packageState[PackageFields.TARGETING]?.[field]?.keywords?.excludes?.length
      );
    }

    if (field === TargetingFields.ADVANCED_TARGETING || field === TargetingFields.CUSTOM_VARIABLES) {
      const hasCustomVariables = Boolean(
        packageState[PackageFields.TARGETING]?.[TargetingFields.CUSTOM_VARIABLES]?.custom?.length
      );

      // Without its own card, contextual segments are shown in the Custom Targeting card
      return hasCustomVariables || (!hasContextualSegmentsCard && hasContextualSegments);
    }

    if (field === TargetingFields.CONTEXTUAL_SEGMENTS) {
      return hasContextualSegments;
    }

    if (field === TargetingFields.URL_TARGETING && !isOa) {
      return packageState[PackageFields.TARGETING]?.[field]?.urls?.length;
    }

    if (field === TargetingFields.APP_INVENTORY) {
      const appInventory = packageState[PackageFields.TARGETING]?.[field];

      return !!appInventory?.app_bundle_id || !!appInventory?.appgroup;
    }

    return packageState[PackageFields.TARGETING]?.[field];
  });
};
